export enum LocaleEnum {
  EN_US = 'en-US',
  ES_MX = 'es-MX',
}
